import React from 'react';
import styled from "styled-components";

import LoadingComponent from './LoadingComponent.jsx';

class PlotViewLoadingComponent extends React.Component {
    state = {
        progress: -1,
        prefix: '',
        message: ''
    }

    subscriptions = []

    componentDidMount () {
        // handler for formula errors from plot: display with formula or clear error state
        this.props.Dyn.mediatorLocalSubscribe( this.subscriptions, "plot:indicateProgress", ( data ) => {
            let progress, prefix, message;
            if ( data.message ) {
                // show message like "Generating Samples"
                prefix = data.prefix || ''; // set or clear prefix for future messages
                progress = 0; // to make sure message is visible
                message = data.message; // message to display
            } else if ( data.prefix ) {
                // show 'Loading Distribution'
                prefix = data.prefix;
                progress = data.progress || 0; // progress is 0% until explicitly change
                message = this.props.Dyn.loc('Loading {{prefix}}', {prefix: prefix});
            } else if( data.progress >= 0 ){
                // show 'Loading NN%' with optional prefix like 'Loading Distribution NN%', until prefix cleared
                prefix = data.prefix || this.state.prefix || ''; // reuse last prefix until cleared
                progress = data.progress || 0; // progress is 0% until explicitly change
                message = this.props.Dyn.loc('Loading {{prefix}}{{num}}%', {prefix: prefix, num: progress});
            } else {
                // hide the progress indicator and clear the prefix
                progress = -1;
                message = prefix = '';
            }
            this.setState({
                progress: progress,
                prefix: prefix,
                message: message
            });
        });
    }

    componentWillUnmount () {
        this.props.Dyn.mediatorLocalRemoveAll( this.subscriptions );
    }

    render () {
        if(this.state.progress === -1) {
            return '';
        }
        const Wrapper = styled.div`
            position: absolute;
            top: calc(50% - 45px);
            left: calc(50% - 95px);
            background-color: #000000ba;
            padding: 20px 30px 16px;
            border-radius: 5px;
            z-index: 999;
            width: 205px;
        `;
        return (
            <Wrapper>
                <LoadingComponent theme="dark" label={ this.state.message }/>
            </Wrapper>
        )
    }
}

export default PlotViewLoadingComponent;
